module.exports = __webpack_public_path__ + "img/logo_9.8688e4dd.png";